import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { Alert, Row, theme, Typography } from 'antd';
import { useOrder } from 'pos-client/hooks/useOrder.tsx';

export const RefundBanner = forwardRef<HTMLDivElement>((_props, ref) => {
  const { token } = theme.useToken();
  const { t } = useTranslation();

  const { id: orderId } = useParams<'id'>();
  const { order, isLoadingOrder } = useOrder({ orderId });

  if (!isLoadingOrder && order?.orderType === 'Refund' && order?.referenceId)
    return (
      <div
        ref={ref}
        style={{
          marginTop: token.marginSM,
          position: 'sticky',
          top: 0,
          zIndex: 100,
        }}
      >
        <Alert
          type="warning"
          style={{
            borderRadius: 0,
          }}
          message={
            <Row justify="center">
              <Typography.Text strong type="warning">
                {t('orders.refundBannerNote')}
              </Typography.Text>
            </Row>
          }
        />
      </div>
    );

  return <></>;
});
